import { default as _91id_93k8bMombrDoMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/admin/catalog/brands/[id].vue?macro=true";
import { default as indexcC1mME8lrXMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/admin/catalog/brands/index.vue?macro=true";
import { default as categories0mgm4FyL6rMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/admin/catalog/categories.vue?macro=true";
import { default as _91id_93uXVYfrvOsWMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/admin/catalog/seeds/[id].vue?macro=true";
import { default as indexH7DZ9yZvUUMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/admin/catalog/seeds/index.vue?macro=true";
import { default as suggestionsk3Aa4vHPEIMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/admin/catalog/suggestions.vue?macro=true";
import { default as catalogGUXeJ2vmvqMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/admin/catalog.vue?macro=true";
import { default as community9Jklf6ybeeMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/admin/community.vue?macro=true";
import { default as index768Ryeu9CcMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/admin/index.vue?macro=true";
import { default as index0v9cVBT5qVMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/admin/pages/index.vue?macro=true";
import { default as indexIlValAYOmWMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/admin/reports/index.vue?macro=true";
import { default as agreement7dzSBNzRgMMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/agreement.vue?macro=true";
import { default as _91code_93OBOGddpKiiMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/auth/activate/[code].vue?macro=true";
import { default as _91code_93vyXQvu2WjEMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/auth/remind/[code].vue?macro=true";
import { default as indexhoJNdO3dh4Meta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/auth/remind/index.vue?macro=true";
import { default as signin0ceniJT6IIMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/auth/signin.vue?macro=true";
import { default as signupRqDjj55gUOMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/auth/signup.vue?macro=true";
import { default as _91subcategory_93clhgb1EoDzMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/[category]/[subcategory].vue?macro=true";
import { default as indexqbOFfAlgXLMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/[category]/index.vue?macro=true";
import { default as authors8YNa9Z0sf4Meta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/authors.vue?macro=true";
import { default as index54T7MF4j8XMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/brands/[id]/index.vue?macro=true";
import { default as reviewsNmlOU5qYvVMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/brands/[id]/reviews.vue?macro=true";
import { default as seedsLNLprbwnwRMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/brands/[id]/seeds.vue?macro=true";
import { default as _91id_93UoY9YHMJrCMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/brands/[id].vue?macro=true";
import { default as indexly6lzJOlsBMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/brands/index.vue?macro=true";
import { default as _91slug_93wKgsGqJNiIMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/families/[slug].vue?macro=true";
import { default as indexeuobfSFNEXMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/index.vue?macro=true";
import { default as new_45plants2NErQN4A8zMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/new-plants.vue?macro=true";
import { default as photosTRE3Itw5PxMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/photos.vue?macro=true";
import { default as product_45_91id_93736CAKo1UhMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/product-[id].vue?macro=true";
import { default as ratingxPz65Q0b2KMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/rating.vue?macro=true";
import { default as recordsa2Dp5I0v1TMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/records.vue?macro=true";
import { default as reviewsO1caEv3K37Meta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/reviews.vue?macro=true";
import { default as compareT6GfxNxFllMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/compare.vue?macro=true";
import { default as _91id_93CpyxukoDF1Meta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/experiments/[id].vue?macro=true";
import { default as addsiak9AejyTMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/experiments/add.vue?macro=true";
import { default as _91id_9393KT0sVXgBMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/experiments/edit/[id].vue?macro=true";
import { default as indexE0YzcN69VLMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/experiments/index.vue?macro=true";
import { default as editTgBur9dA84Meta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/feed/[id]/edit.vue?macro=true";
import { default as edit2kj1TqH4OYyMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/feed/[id]/edit2.vue?macro=true";
import { default as indexk8QWtqeye8Meta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/feed/[id]/index.vue?macro=true";
import { default as indexF51yyNl0xQMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/feed/index.vue?macro=true";
import { default as _91slug_93JaZiswSiyvMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/gardens/[slug].vue?macro=true";
import { default as indexlCCImOp6yAMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/gardens/index.vue?macro=true";
import { default as indexK4V6XGIRlKMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/group/[id]/index.vue?macro=true";
import { default as newENGlcg0aZYMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/group/[id]/post/new.vue?macro=true";
import { default as userszbQw6rdfmiMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/group/[id]/users.vue?macro=true";
import { default as addLnt69I9hsJMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/groups/add.vue?macro=true";
import { default as _91id_936Eb1AV5mILMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/groups/edit/[id].vue?macro=true";
import { default as indexWwdGPIxE7cMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/groups/index.vue?macro=true";
import { default as updatesqbn4iNKWAtMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/groups/updates.vue?macro=true";
import { default as catalogwrcGIfADBTMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/help/catalog.vue?macro=true";
import { default as contacthbAf6M1DlWMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/help/contact.vue?macro=true";
import { default as dnevnik_45sadovodaukjWZNOW9zMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/help/dnevnik-sadovoda.vue?macro=true";
import { default as download_45appCVyNGPRKfwMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/help/download-app.vue?macro=true";
import { default as downloadBNqKCihyQqMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/help/download.vue?macro=true";
import { default as feedw5sEg1PnqWMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/help/feed.vue?macro=true";
import { default as index8T76esG6vsMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/help/index.vue?macro=true";
import { default as infoL19pYkl9cbMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/help/info.vue?macro=true";
import { default as manualsuEmsFoCKAbMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/help/manuals.vue?macro=true";
import { default as printadi2u6anjiMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/help/print.vue?macro=true";
import { default as profileXxlwTXKTQVMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/help/profile.vue?macro=true";
import { default as startF3Y0eKSQtDMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/help/start.vue?macro=true";
import { default as indexUfAu6YgAZJMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/index.vue?macro=true";
import { default as importmjEbGVMQFFMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/journal/import.vue?macro=true";
import { default as _91slug_935TFoyFQCp9Meta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/manuals/[slug].vue?macro=true";
import { default as gryadki_45v_45teplice_45svoimi_45rukamiCSbhuABSpsMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/manuals/gryadki-v-teplice-svoimi-rukami.vue?macro=true";
import { default as indexavL3AIxAHhMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/manuals/index.vue?macro=true";
import { default as _91slug_93etxHeFshTwMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/manuals/preview/[slug].vue?macro=true";
import { default as teplica_45iz_45polikarbonata_45svoimi_45rukamiRczyuZO8FdMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/manuals/teplica-iz-polikarbonata-svoimi-rukami.vue?macro=true";
import { default as teplica_45svoimi_45rukami_45iz_45derevakLgBgnxidEMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/manuals/teplica-svoimi-rukami-iz-dereva.vue?macro=true";
import { default as teplica_45svoimi_45rukami_45iz_45profilnoy_45truby6NLqF8tB6BMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/manuals/teplica-svoimi-rukami-iz-profilnoy-truby.vue?macro=true";
import { default as teplitsa_45svoimi_45rukamiVgUmFOgD4GMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/manuals/teplitsa-svoimi-rukami.vue?macro=true";
import { default as messagesK2WPffxHPIMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/messages.vue?macro=true";
import { default as o_45proektejCkqSgUoUgMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/o-proekte.vue?macro=true";
import { default as print_45_91_46_46_46segments_9311QxIlZfTPMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/print-[...segments].vue?macro=true";
import { default as privacyCJXOqU5GFoMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/privacy.vue?macro=true";
import { default as achievementshlg7LiDllIMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/achievements.vue?macro=true";
import { default as blogRHZ9fffrGBMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/blog.vue?macro=true";
import { default as commentsJCNdvDzYNNMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/comments.vue?macro=true";
import { default as editFrrMfBkDBuMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/edit.vue?macro=true";
import { default as experimentsgU2CkZMfCVMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/experiments.vue?macro=true";
import { default as favoritey53DejHT8vMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/favorite.vue?macro=true";
import { default as _91_46_46_46segments_93anhv1poqKTMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/gardens/[...segments].vue?macro=true";
import { default as groupsy3QWcFoXm7Meta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/groups.vue?macro=true";
import { default as grownflH4CE49SfMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/grown.vue?macro=true";
import { default as indexlleDLzZuhNMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/index.vue?macro=true";
import { default as recordsx0AFUNPPaLMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/records.vue?macro=true";
import { default as reviewskX56MvQmKvMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/reviews.vue?macro=true";
import { default as seedsuYXyPCyWBOMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/seeds.vue?macro=true";
import { default as settingstkMIIX3Ty3Meta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/settings.vue?macro=true";
import { default as statisticswBEDFDcxRTMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/statistics.vue?macro=true";
import { default as tasks91v6iK1kvwMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/tasks.vue?macro=true";
import { default as _91id_93xcarbab7tAMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id].vue?macro=true";
import { default as indexS7MQXbLMyNMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/index.vue?macro=true";
import { default as ratingsNJGSVlvZVuMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/ratings.vue?macro=true";
import { default as _91id_93XMPMhNXtofMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/questions/[id].vue?macro=true";
import { default as askMtZTKKAupbMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/questions/ask.vue?macro=true";
import { default as indexVcPmA1QRUDMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/questions/index.vue?macro=true";
import { default as _91slug_93KAI4tV0DowMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/selections/[slug].vue?macro=true";
import { default as indexLsX8JVyOUvMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/selections/index.vue?macro=true";
import { default as _91_46_46_46filters_93MJ9GJuGFJCMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/tops/[subcategory]/[...filters].vue?macro=true";
import { default as indexqSpGcyX7c7Meta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/tops/[subcategory]/index.vue?macro=true";
import { default as index3L7RPXLMw8Meta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/tops/index.vue?macro=true";
import { default as ranniewpG0qVGXfsMeta } from "/home/dev/uogorod-build-catalog-entry-20261105/pages/tops/tomat/rannie.vue?macro=true";
import { default as component_45stubDCwIVDcn9JMeta } from "/home/dev/uogorod-src/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubDCwIVDcn9J } from "/home/dev/uogorod-src/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "admin-catalog",
    path: "/admin/catalog",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/admin/catalog.vue"),
    children: [
  {
    name: "admin-catalog-brands-id",
    path: "brands/:id()",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/admin/catalog/brands/[id].vue")
  },
  {
    name: "admin-catalog-brands",
    path: "brands",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/admin/catalog/brands/index.vue")
  },
  {
    name: "admin-catalog-categories",
    path: "categories",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/admin/catalog/categories.vue")
  },
  {
    name: "admin-catalog-seeds-id",
    path: "seeds/:id()",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/admin/catalog/seeds/[id].vue")
  },
  {
    name: "admin-catalog-seeds",
    path: "seeds",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/admin/catalog/seeds/index.vue")
  },
  {
    name: "admin-catalog-suggestions",
    path: "suggestions",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/admin/catalog/suggestions.vue")
  }
]
  },
  {
    name: "admin-community",
    path: "/admin/community",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/admin/community.vue")
  },
  {
    name: "admin",
    path: "/admin",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/admin/index.vue")
  },
  {
    name: "admin-pages",
    path: "/admin/pages",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/admin/pages/index.vue")
  },
  {
    name: "admin-reports",
    path: "/admin/reports",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/admin/reports/index.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/agreement.vue")
  },
  {
    name: "auth-activate-code",
    path: "/auth/activate/:code()",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/auth/activate/[code].vue")
  },
  {
    name: "auth-remind-code",
    path: "/auth/remind/:code()",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/auth/remind/[code].vue")
  },
  {
    name: "auth-remind",
    path: "/auth/remind",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/auth/remind/index.vue")
  },
  {
    name: "auth-signin",
    path: "/auth/signin",
    meta: signin0ceniJT6IIMeta || {},
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/auth/signin.vue")
  },
  {
    name: "auth-signup",
    path: "/auth/signup",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/auth/signup.vue")
  },
  {
    name: "catalog-category-subcategory",
    path: "/catalog/:category()/:subcategory()",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/[category]/[subcategory].vue")
  },
  {
    name: "catalog-category",
    path: "/catalog/:category()",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/[category]/index.vue")
  },
  {
    name: "catalog-authors",
    path: "/catalog/authors",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/authors.vue")
  },
  {
    name: _91id_93UoY9YHMJrCMeta?.name,
    path: "/catalog/brands/:id()",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/brands/[id].vue"),
    children: [
  {
    name: "catalog-brands-id",
    path: "",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/brands/[id]/index.vue")
  },
  {
    name: "catalog-brands-id-reviews",
    path: "reviews",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/brands/[id]/reviews.vue")
  },
  {
    name: "catalog-brands-id-seeds",
    path: "seeds",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/brands/[id]/seeds.vue")
  }
]
  },
  {
    name: "catalog-brands",
    path: "/catalog/brands",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/brands/index.vue")
  },
  {
    name: "catalog-families-slug",
    path: "/catalog/families/:slug()",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/families/[slug].vue")
  },
  {
    name: "catalog",
    path: "/catalog",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/index.vue")
  },
  {
    name: "catalog-new-plants",
    path: "/catalog/new-plants",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/new-plants.vue")
  },
  {
    name: "catalog-photos",
    path: "/catalog/photos",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/photos.vue")
  },
  {
    name: "catalog-product-id",
    path: "/catalog/product-:id()",
    meta: product_45_91id_93736CAKo1UhMeta || {},
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/product-[id].vue")
  },
  {
    name: "catalog-rating",
    path: "/catalog/rating",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/rating.vue")
  },
  {
    name: "catalog-records",
    path: "/catalog/records",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/records.vue")
  },
  {
    name: "catalog-reviews",
    path: "/catalog/reviews",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/catalog/reviews.vue")
  },
  {
    name: "compare",
    path: "/compare",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/compare.vue")
  },
  {
    name: "experiments-id",
    path: "/experiments/:id()",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/experiments/[id].vue")
  },
  {
    name: "experiments-add",
    path: "/experiments/add",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/experiments/add.vue")
  },
  {
    name: "experiments-edit-id",
    path: "/experiments/edit/:id()",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/experiments/edit/[id].vue")
  },
  {
    name: "experiments",
    path: "/experiments",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/experiments/index.vue")
  },
  {
    name: "feed-id-edit",
    path: "/feed/:id()/edit",
    meta: editTgBur9dA84Meta || {},
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/feed/[id]/edit.vue")
  },
  {
    name: "feed-id-edit2",
    path: "/feed/:id()/edit2",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/feed/[id]/edit2.vue")
  },
  {
    name: "feed-id",
    path: "/feed/:id()",
    meta: indexk8QWtqeye8Meta || {},
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/feed/[id]/index.vue")
  },
  {
    name: "feed",
    path: "/feed",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/feed/index.vue")
  },
  {
    name: "gardens-slug",
    path: "/gardens/:slug()",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/gardens/[slug].vue")
  },
  {
    name: "gardens",
    path: "/gardens",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/gardens/index.vue")
  },
  {
    name: "group-id",
    path: "/group/:id()",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/group/[id]/index.vue")
  },
  {
    name: "group-id-post-new",
    path: "/group/:id()/post/new",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/group/[id]/post/new.vue")
  },
  {
    name: "group-id-users",
    path: "/group/:id()/users",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/group/[id]/users.vue")
  },
  {
    name: "groups-add",
    path: "/groups/add",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/groups/add.vue")
  },
  {
    name: "groups-edit-id",
    path: "/groups/edit/:id()",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/groups/edit/[id].vue")
  },
  {
    name: "groups",
    path: "/groups",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/groups/index.vue")
  },
  {
    name: "groups-updates",
    path: "/groups/updates",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/groups/updates.vue")
  },
  {
    name: "help-catalog",
    path: "/help/catalog",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/help/catalog.vue")
  },
  {
    name: "help-contact",
    path: "/help/contact",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/help/contact.vue")
  },
  {
    name: "help-dnevnik-sadovoda",
    path: "/help/dnevnik-sadovoda",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/help/dnevnik-sadovoda.vue")
  },
  {
    name: "help-download-app",
    path: "/help/download-app",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/help/download-app.vue")
  },
  {
    name: "help-download",
    path: "/help/download",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/help/download.vue")
  },
  {
    name: "help-feed",
    path: "/help/feed",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/help/feed.vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/help/index.vue")
  },
  {
    name: "help-info",
    path: "/help/info",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/help/info.vue")
  },
  {
    name: "help-manuals",
    path: "/help/manuals",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/help/manuals.vue")
  },
  {
    name: "help-print",
    path: "/help/print",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/help/print.vue")
  },
  {
    name: "help-profile",
    path: "/help/profile",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/help/profile.vue")
  },
  {
    name: "help-start",
    path: "/help/start",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/help/start.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexUfAu6YgAZJMeta || {},
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/index.vue")
  },
  {
    name: "journal-import",
    path: "/journal/import",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/journal/import.vue")
  },
  {
    name: "manuals-slug",
    path: "/manuals/:slug()",
    meta: _91slug_935TFoyFQCp9Meta || {},
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/manuals/[slug].vue")
  },
  {
    name: "manuals-gryadki-v-teplice-svoimi-rukami",
    path: "/manuals/gryadki-v-teplice-svoimi-rukami",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/manuals/gryadki-v-teplice-svoimi-rukami.vue")
  },
  {
    name: "manuals",
    path: "/manuals",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/manuals/index.vue")
  },
  {
    name: "manuals-preview-slug",
    path: "/manuals/preview/:slug()",
    meta: _91slug_93etxHeFshTwMeta || {},
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/manuals/preview/[slug].vue")
  },
  {
    name: "manuals-teplica-iz-polikarbonata-svoimi-rukami",
    path: "/manuals/teplica-iz-polikarbonata-svoimi-rukami",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/manuals/teplica-iz-polikarbonata-svoimi-rukami.vue")
  },
  {
    name: "manuals-teplica-svoimi-rukami-iz-dereva",
    path: "/manuals/teplica-svoimi-rukami-iz-dereva",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/manuals/teplica-svoimi-rukami-iz-dereva.vue")
  },
  {
    name: "manuals-teplica-svoimi-rukami-iz-profilnoy-truby",
    path: "/manuals/teplica-svoimi-rukami-iz-profilnoy-truby",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/manuals/teplica-svoimi-rukami-iz-profilnoy-truby.vue")
  },
  {
    name: "manuals-teplitsa-svoimi-rukami",
    path: "/manuals/teplitsa-svoimi-rukami",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/manuals/teplitsa-svoimi-rukami.vue")
  },
  {
    name: "messages",
    path: "/messages",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/messages.vue")
  },
  {
    name: "o-proekte",
    path: "/o-proekte",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/o-proekte.vue")
  },
  {
    name: "print-segments",
    path: "/print-:segments(.*)*",
    meta: print_45_91_46_46_46segments_9311QxIlZfTPMeta || {},
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/print-[...segments].vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/privacy.vue")
  },
  {
    name: _91id_93xcarbab7tAMeta?.name,
    path: "/profiles/:id()",
    meta: _91id_93xcarbab7tAMeta || {},
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id].vue"),
    children: [
  {
    name: "profiles-id-achievements",
    path: "achievements",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/achievements.vue")
  },
  {
    name: "profiles-id-blog",
    path: "blog",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/blog.vue")
  },
  {
    name: "profiles-id-comments",
    path: "comments",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/comments.vue")
  },
  {
    name: "profiles-id-edit",
    path: "edit",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/edit.vue")
  },
  {
    name: "profiles-id-experiments",
    path: "experiments",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/experiments.vue")
  },
  {
    name: "profiles-id-favorite",
    path: "favorite",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/favorite.vue")
  },
  {
    name: "profiles-id-gardens-segments",
    path: "gardens/:segments(.*)*",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/gardens/[...segments].vue")
  },
  {
    name: "profiles-id-groups",
    path: "groups",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/groups.vue")
  },
  {
    name: "profiles-id-grown",
    path: "grown",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/grown.vue")
  },
  {
    name: "profiles-id",
    path: "",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/index.vue")
  },
  {
    name: "profiles-id-records",
    path: "records",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/records.vue")
  },
  {
    name: "profiles-id-reviews",
    path: "reviews",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/reviews.vue")
  },
  {
    name: "profiles-id-seeds",
    path: "seeds",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/seeds.vue")
  },
  {
    name: "profiles-id-settings",
    path: "settings",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/settings.vue")
  },
  {
    name: "profiles-id-statistics",
    path: "statistics",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/statistics.vue")
  },
  {
    name: "profiles-id-tasks",
    path: "tasks",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/[id]/tasks.vue")
  }
]
  },
  {
    name: "profiles",
    path: "/profiles",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/index.vue")
  },
  {
    name: "profiles-ratings",
    path: "/profiles/ratings",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/profiles/ratings.vue")
  },
  {
    name: "questions-id",
    path: "/questions/:id()",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/questions/[id].vue")
  },
  {
    name: "questions-ask",
    path: "/questions/ask",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/questions/ask.vue")
  },
  {
    name: "questions",
    path: "/questions",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/questions/index.vue")
  },
  {
    name: "selections-slug",
    path: "/selections/:slug()",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/selections/[slug].vue")
  },
  {
    name: "selections",
    path: "/selections",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/selections/index.vue")
  },
  {
    name: "tops-subcategory-filters",
    path: "/tops/:subcategory()/:filters(.*)*",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/tops/[subcategory]/[...filters].vue")
  },
  {
    name: "tops-subcategory",
    path: "/tops/:subcategory()",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/tops/[subcategory]/index.vue")
  },
  {
    name: "tops",
    path: "/tops",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/tops/index.vue")
  },
  {
    name: "tops-tomat-rannie",
    path: "/tops/tomat/rannie",
    component: () => import("/home/dev/uogorod-build-catalog-entry-20261105/pages/tops/tomat/rannie.vue")
  },
  {
    name: component_45stubDCwIVDcn9JMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubDCwIVDcn9J
  },
  {
    name: component_45stubDCwIVDcn9JMeta?.name,
    path: "/catalog-sitemap.xml",
    component: component_45stubDCwIVDcn9J
  },
  {
    name: component_45stubDCwIVDcn9JMeta?.name,
    path: "/brands-sitemap.xml",
    component: component_45stubDCwIVDcn9J
  },
  {
    name: component_45stubDCwIVDcn9JMeta?.name,
    path: "/feed-sitemap.xml",
    component: component_45stubDCwIVDcn9J
  },
  {
    name: component_45stubDCwIVDcn9JMeta?.name,
    path: "/products-sitemap.xml",
    component: component_45stubDCwIVDcn9J
  },
  {
    name: component_45stubDCwIVDcn9JMeta?.name,
    path: "/profiles-sitemap.xml",
    component: component_45stubDCwIVDcn9J
  }
]